import { render, staticRenderFns } from "./ApiDocPage.vue?vue&type=template&id=63af5a8c&scoped=true"
import script from "./ApiDocPage.vue?vue&type=script&lang=js"
export * from "./ApiDocPage.vue?vue&type=script&lang=js"
import style0 from "./ApiDocPage.vue?vue&type=style&index=0&id=63af5a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af5a8c",
  null
  
)

export default component.exports